import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheetComparison } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useTermSheetComparisonQuery(
	dataRoomGuid?: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<TermSheetComparison, unknown, TermSheetComparison, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.Comparison(dataRoomGuid),
		() =>
			AxiosUtils.getResponseData<TermSheetComparison>(
				api.get(CerebroApiEndpoints.TermSheets.Comparison(dataRoomGuid))
			),
		options
	);
}
